import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const LockOpenSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default LockOpenSVG;
